var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-select", {
    style: {
      width: (_vm.width || 150) + "px"
    },
    attrs: {
      multiple: _vm.multiple,
      placeholder: "请选择",
      clearable: "",
      filterable: _vm.filterable
    },
    on: {
      change: function change($event) {
        return _vm.someSelect();
      }
    },
    model: {
      value: _vm.label,
      callback: function callback($$v) {
        _vm.label = $$v;
      },
      expression: "label"
    }
  }, [_vm.all ? _c("el-option", {
    attrs: {
      label: _vm.allOption.label,
      value: _vm.allOption.id
    }
  }) : _vm._e(), _vm._l(_vm.serverList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.label,
        value: item.id
      }
    });
  })], 2)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };